module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ModalTheme', {
    attrs: {
      "overlay": false,
      "loading": _vm.loading || _vm.parentLoading
    },
    on: {
      "close": _vm.cancel
    }
  }, [_c('template', {
    slot: "main"
  }, [_c('h1', {
    staticClass: "txtCenter",
    staticStyle: {
      "font-size": "xx-large"
    }
  }, [_vm._v(_vm._s("Create version"))]), _vm._v(" "), _c('form', {
    attrs: {
      "data-vv-scope": "form-1"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.validateForm('form-1');
      }
    }
  }, [_c('table', {
    attrs: {
      "cellpadding": "4px"
    }
  }, [_c('tr', [_c('td', [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Nom")])]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "textfield",
    class: {
      'textfield-error': _vm.hasError('form-1.name')
    },
    attrs: {
      "id": "name",
      "type": "text",
      "name": "name"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('label', {
    attrs: {
      "for": "version"
    }
  }, [_vm._v("Version")])]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.upcoming ? '' : 'required'),
      expression: "upcoming ? '' : 'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.version),
      expression: "version"
    }],
    staticClass: "textfield",
    class: {
      'textfield-error': _vm.hasError('form-1.version')
    },
    attrs: {
      "id": "version",
      "type": "text",
      "name": "version"
    },
    domProps: {
      "value": (_vm.version)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.version = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('label', {
    attrs: {
      "for": "date"
    }
  }, [_vm._v("Date")])]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.upcoming ? '' : 'required'),
      expression: "upcoming ? '' : 'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dateTmp),
      expression: "dateTmp"
    }],
    staticClass: "textfield",
    class: {
      'textfield-error': _vm.hasError('form-1.date')
    },
    attrs: {
      "id": "date",
      "type": "date",
      "name": "date"
    },
    domProps: {
      "value": (_vm.dateTmp)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dateTmp = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('label', {
    attrs: {
      "for": "message"
    }
  }, [_vm._v("Message")]), _vm._v(" "), _c('div', {
    staticClass: "content-message"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    staticClass: "textfield",
    attrs: {
      "id": "message",
      "rows": "10"
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('input', {
    directives: [{
      name: "checked",
      rawName: "v-checked",
      value: (_vm.upcoming),
      expression: "upcoming"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.upcoming),
      expression: "upcoming"
    }],
    attrs: {
      "type": "checkbox",
      "id": "upcoming",
      "name": "upcoming"
    },
    domProps: {
      "checked": Array.isArray(_vm.upcoming) ? _vm._i(_vm.upcoming, null) > -1 : (_vm.upcoming)
    },
    on: {
      "change": _vm.changeUpcoming,
      "__c": function($event) {
        var $$a = _vm.upcoming,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.upcoming = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.upcoming = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.upcoming = $$c
        }
      }
    }
  }), _c('label', {
    attrs: {
      "for": "upcoming"
    }
  }, [_vm._v(_vm._s(_vm.$t("versioning.upcoming")))])])])]), _vm._v(" "), _c('div', {
    staticClass: "txtRight"
  }, [_c('button', {
    staticClass: "btn btn-dark",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.cancel($event)
      }
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-dark",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Enregistrer")])])])]), _vm._v(" "), _c('template', {
    slot: "footer"
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-804b2156","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/versioning/Versioning.vue
// module id = 3296
// module chunks = 0